import { createGlobalStyle } from "styled-components";
import Segment7Woff from "./fonts/Segment7Standard.woff";
import Segment7Woff2 from "./fonts/Segment7Standard.woff2";

const FontStyles = createGlobalStyle`

@font-face {
  font-family: 'Segment7';
  src: url(${Segment7Woff2}) format('woff2'),
       url(${Segment7Woff}) format('woff');
font-weight: normal;
font-style: italic;
font-display: swap;
}
`;

export default FontStyles;